import {
  DecoratorNode,
  DOMExportOutput,
  type SerializedLexicalNode,
} from "lexical";
import { CasTableNodeRenderer } from "./CasTableNodeRenderer";

export interface IDataTableConfig {
  renderDataObjectUrl: string;
  dataObject: {
    type: 'SCE-List',
    layout?: string,
    request: {
      url: string;
      params: Record<string, any>;
    }
  }
};

export type SerializedDataTableNode = {
  renderDataObjectUrl: IDataTableConfig['renderDataObjectUrl'];
  dataObject: IDataTableConfig['dataObject'];
} & SerializedLexicalNode;

export class CasTableDataNode extends DecoratorNode<JSX.Element> {
  __renderDataObjectUrl: string;
  __dataObject: IDataTableConfig['dataObject'];

  static getType() {
    return "data-table";
  }

  static clone(node: CasTableDataNode) {
    return new CasTableDataNode(
      node.__renderDataObjectUrl, 
      node.__dataObject, 
      node.__key
    );
  }

  constructor(
    renderDataObjectUrl: string, 
    dataObject: IDataTableConfig['dataObject'], 
    key?: string
  ) {
    super(key);
    this.__renderDataObjectUrl = renderDataObjectUrl;
    this.__dataObject = dataObject;
  }

  createDOM() {
    const div = document.createElement("div");
    return div;
  }

  updateDOM() {
    return false;
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('dataObject');
    element.textContent = JSON.stringify(this.__dataObject);

    return { element };
  }

  static importJSON(serialized: SerializedDataTableNode) {
    return new CasTableDataNode(
      serialized.renderDataObjectUrl,
      serialized.dataObject,
    );
  }

  exportJSON(): SerializedDataTableNode {
    return {
      type: "data-table",
      version: 1,
      renderDataObjectUrl: this.__renderDataObjectUrl,
      dataObject: this.__dataObject,
    };
  }

  decorate() {
    return (
      <CasTableNodeRenderer
        renderDataObjectUrl={this.__renderDataObjectUrl}
        dataObject={this.__dataObject}
        nodeKey={this.getKey()}
      />
    );
  }
}

export function $createCasDataTableNode(dataTableConfig: IDataTableConfig) {
  return new CasTableDataNode(dataTableConfig.renderDataObjectUrl, dataTableConfig.dataObject);
}
